import React, { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

/**
 * Full-screen overlay with a spinner and cycling status messages.
 * @param {string[]} messageKeys - i18n keys, rotated every `intervalMs`
 */
function StatusLoadingOverlay({ messageKeys = [], intervalMs = 2000 }) {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const messages = messageKeys.map(key => t(key));

  useEffect(() => {
    setIndex(0);
  }, [messageKeys.join('|')]);

  useEffect(() => {
    if (messages.length <= 1) return undefined;
    const timer = setInterval(() => {
      setIndex(i => (i + 1) % messages.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [messages.length, intervalMs]);

  if (!messages.length) return null;

  return (
    <div
      className='fixed inset-0 z-[9999] flex flex-col items-center justify-center gap-4'
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.55)' }}
      role='status'
      aria-live='polite'
      aria-busy='true'
    >
      <Spinner animation='border' style={{ width: '3rem', height: '3rem', color: '#fff' }}>
        <span className='visually-hidden'>{messages[index]}</span>
      </Spinner>
      <p className='max-w-sm px-8 text-center text-sm font-medium text-white'>{messages[index]}</p>
    </div>
  );
}

export default StatusLoadingOverlay;
